import { faDownload } from '@fortawesome/pro-regular-svg-icons';
import { faDownload as faSolidDownload } from '@fortawesome/pro-solid-svg-icons';
import { UploadFileInfo } from '@progress/kendo-react-upload';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { InfoPopup } from 'components/popup/InfoPopup';
import { SingleUpload } from 'components/upload/SingleUpload';
import { maxFileSizeBytes } from 'pages/Models/AnalyticsModelTab/shared';
import styled from 'styled-components';
import { useThemeValues } from 'styles/theme';
import { downloadModelSourceCodeTemplate } from 'utils/analytics_model';

const SourceCodeUpload = styled.div`
    display: grid;
    grid-template-columns: 1fr auto auto;
    column-gap: 0rem;
`;

const SourceCodeUploadIcon = styled.div`
    width: 3rem;
    text-align: center;
    padding-top: 1.5rem;
`;

const CodeStyled = styled.span`
    font-family: monospace;
    font-weight: bold;
`;

export type SourceCodeInputProps = Readonly<{
    value: UploadFileInfo | undefined;
    onChange: (newValue: UploadFileInfo | undefined) => void;
}>;

export function SourceCodeInput({ value, onChange }: SourceCodeInputProps) {
    const { secondaryText } = useThemeValues();

    return (
        <SourceCodeUpload>
            <div>
                <SingleUpload
                    file={value}
                    onChange={onChange}
                    restrictions={{
                        allowedExtensions: ['.zip'],
                        maxFileSize: maxFileSizeBytes,
                    }}
                />
            </div>
            <SourceCodeUploadIcon>
                <InfoPopup title="File type">
                    Source code must be a <CodeStyled>.zip</CodeStyled> file containing a{' '}
                    <CodeStyled>main.py</CodeStyled> file.
                </InfoPopup>
            </SourceCodeUploadIcon>
            <SourceCodeUploadIcon>
                <HoverIconButton
                    icon={faDownload}
                    hoverIcon={faSolidDownload}
                    color={secondaryText}
                    onClick={downloadModelSourceCodeTemplate}
                    title="Download source code template"
                    className="align-self-center"
                />
            </SourceCodeUploadIcon>
        </SourceCodeUpload>
    );
}
